import React from "react";
import { StoryAudienceSection } from "../StoryAudienceSection";
import { StoryDetailsFields } from "../StoryDetailsFields";
import { audienceKeyPatch } from "../../../services/dataStories/storyDetailsAudience";
import type { AiStoryDetailsStepProps } from "./AiStoryDetailsStep.types";

/**
 * AI-method details step body — Figma 5326:88121.
 *
 * Goal and Sources come from `StoryDetailsFields`, shared with the agent frame
 * (5326:88960); this file adds only the Audience field that sits between them
 * and the frame does not otherwise differ. Stateless: the whole form lives in
 * `values`, every edit goes out as a patch, and the workspace data the sources
 * picker needs arrives in `context` from the flow organism.
 */
export const AiStoryDetailsStep: React.FC<AiStoryDetailsStepProps> = ({
  values,
  onChange,
  context,
}) => {
  const handleAudienceKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const patch = audienceKeyPatch(e.key, values);
    if (!patch) return;
    // The body sits inside a modal; without this an Enter would bubble to the
    // dialog and trip the footer's Continue.
    e.preventDefault();
    onChange(patch);
  };

  return (
    <StoryDetailsFields values={values} onChange={onChange} context={context}>
      <StoryAudienceSection
        variant="modal"
        audiences={values.audiences}
        audienceInput={values.audienceDraft}
        isAddingAudience={values.isAddingAudience}
        onAudienceInputChange={(audienceDraft) => onChange({ audienceDraft })}
        onStartAddingAudience={() => onChange({ isAddingAudience: true })}
        onAudienceKeyDown={handleAudienceKeyDown}
        onRemoveAudience={(audience) =>
          onChange({
            audiences: values.audiences.filter((a) => a !== audience),
          })
        }
      />
    </StoryDetailsFields>
  );
};

export default AiStoryDetailsStep;
